import axios, { AxiosRequestConfig, AxiosError } from "axios";

// actions
import { setLoading } from "actions/app.action";
import httpRequest from "./httpRequest";
import { IAppActionTypes } from "models/IAppState";

export type IConfig = AxiosRequestConfig & {
  showSpinner?: boolean;
};

type IAxiosResponse = AxiosError & {
  config: {
    showSpinner?: boolean;
  };
};

function getAccessToken() {
  const accessToken = window.localStorage.getItem("auth_token");
  return accessToken;
}

const requestConfig: IConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
  showSpinner: false,
  headers: {
    // Authorization: `Bearer ${getAccessToken()}`,
  },
};

export const axiosInstance = axios.create(requestConfig);

const { CancelToken } = axios;
let cancel: any = null;

export default function initRequest(store: any) {
  let requestCount = 0;

  function decreaseRequestCount() {
    requestCount -= 1;
    if (requestCount === 0) {
      store.dispatch(setLoading(false));
    }
  }

  axiosInstance.interceptors.request.use(
    (config: IConfig) => {
      // cancel token
      // show loading
      if (config.showSpinner) {
        requestCount += 1;
        store.dispatch(setLoading(true));
      }

      // add x-auth-token only if not already present
      const accessToken = getAccessToken();

      //  if (accessToken) {
      //   config.headers['Authorization'] = `Bearer ${accessToken}`;
      //   // config.headers.Authorization = `Bearer ${accessToken}`;
      // }

      
   if (accessToken && !config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
        // config.headers.Authorization = `Bearer ${accessToken}`;
      }


      return config;
    },
    (error: IAxiosResponse) => {
      if (error.config.showSpinner) {
        decreaseRequestCount();
      }
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res: any) => {
      if (res.config.showSpinner) {
        decreaseRequestCount();
      }
      return res;
    },
    async (error: IAxiosResponse) => {
      console.log("ERROR", error.isAxiosError, error.code);
      if (
        (error && error?.config?.showSpinner) ||
        error.code === "ECONNABORTED"
      ) {
        decreaseRequestCount();
      }

      console.log("axiosInstance.interceptors.response.", error.response);

      // handle request timeout
      if (error.code === "ECONNABORTED") {
        store.dispatch(setLoading(false));
      }

      // access token expired
      if (error.response?.status === 401) {
        // error.config._retry = true;
      }

      // handle errors
      switch (error.response?.status) {
        case 400: {
          break;
        }
        case 500: {
          break;
        }
        case 417: {
          store.dispatch({
            type: IAppActionTypes.ENQUEUE_SNACKBAR,
            payload: {
              message: `Invalid Details`,
              variant: "error",
              key: "common",
            },
          });
          break;
        }
        default:
          break;
      }
      return Promise.reject(error);
    }
  );
}
